import { injectLinkConfig } from '../../../utils/helpUtils';
const id = 'afsp-help-home-badge';

export default class HomeBadge extends React.Component {
    constructor(props) { super(props); }
    componentDidMount() { injectLinkConfig(id); }
    render = () => (
        <div id='afsp-help-home-badge-0' className='ss-home-badge-outer'>
            <div className='ss-home-badge-inner'>
                <div style={{ marginTop: '20px', paddingLeft: '2%' }}>
                    <span className='ss-home-badge-title'>
                        <p>{'Welcome to the TSA Flight Training Security Program (FTSP) portal.'}</p>
                    </span>
                    <span className="ss-home-badge-sub-title">
                        <p>{'FTSP\'s mission is to ensure that non-U.S. citizens and non-U.S. nationals (candidates) participating in flight training do not pose a threat to aviation or national security. ' +
                            'Under '}{<a className='ss-home-badge-link' href="{leg.Section612}" target="_blank">U.S. law</a>}{', U.S. flight training providers may only train candidates for whom TSA has issued a Determination of Eligibility.'}</p>

                        <span style={{ display: 'block', textAlign: 'left' }}>{'Candidates: '}</span>

                        <p>{'You must use this portal to apply for a TSA security threat assessment (STA) and pay the fee.  Upon successful completion of the STA, you will be issued a Determination of Eligibility, which will allow you to train. ' +
                            'Click on '} {<a className='ss-home-badge-link' href="/home/candidateregistration" target="_blank">Register Options</a>} {' to start the process or select Log In if you already have an account.  Select User Guides from the top menu for more information.'}</p>

                        <p style={{ textAlign: 'left' }}>Flight Training Providers:<br />Use this portal for the following actions:</p>

                        <ul>
                            <li style={{ textAlign: 'left' }}>{'Set up an account with TSA. Click on '} {<a className='ss-home-badge-link' href="/home/providerregistration" target="_blank">Register Options</a>} {' to start, or select Log In if you already have an account'}.</li>
                            <li style={{ textAlign: 'left' }}>Notify TSA about candidates requesting training.</li>
                            <li style={{ textAlign: 'left' }}>{'Upload images to comply with the '} {<a className='ss-home-badge-link' href="{leg.ifrPdf}" target="_blank">Regulation</a>}{'.'}</li>
                            <li style={{ textAlign: 'left' }}>{'Access '} {<a className='ss-home-badge-link' href="{leg.ProviderGuideInHome}" target="_blank">user guide and small entity compliance guide</a>}{'.'}</li>
                        </ul>
                    </span>
                </div>
            </div>
        </div>
    );
}
